var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-row align-items-baseline mb-1",
      staticStyle: { "padding-left": "1.25rem" }
    },
    [
      _c(
        "label",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize:100.immediate",
              value: _vm.labelResized,
              expression: "labelResized",
              arg: "100",
              modifiers: { immediate: true }
            }
          ],
          staticClass: "flex-shrink-0 mr-2",
          style: { minWidth: _vm.labelMinWidth + "px" }
        },
        [_vm._v("\n    " + _vm._s(_vm.entry.text) + "\n  ")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.textInput,
            expression: "textInput"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.textInput },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.textInput = $event.target.value
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }